module.exports = __webpack_public_path__ + "img/black_spider_small.52fc64f1.png";